<template>
	<font-awesome-icon
		size="lg"
		:icon="['fas', active ? 'toggle-on' : 'toggle-off']"
		:class="{
			'text-connectProBlue': active,
			'text-gray-500': !active,
			'cursor-pointer': !disabled,
		}"
		v-on="$listeners"
	/>
</template>
<script>
export default {
	name: 'Toggle',
	props: {
		active: { required: true },
		disabled: {},
	},
};
</script>
